import { atom } from "recoil";
import { ToastProps } from "../../components/_";

const toastState = atom<ToastProps[]>({
    key: "toastState",
    default: [],
});

export default toastState;
